export default __webpack_public_path__ + "static/timer-f65ee8091e75c7f7e0c1bedd4239d9c6.png";